import React from 'react';
import QualifiedPlayerCardItem from '../../qualified-player-card/js/QualifiedPlayerCardItem';

export default class QualifiedPlayersListingItem extends React.PureComponent {
    render() {
        return (
            <li
                className={'qualified-players-listing__grid-item'}>
                <QualifiedPlayerCardItem {...this.props}/>
            </li>
        );
    }
}
